module.exports = __webpack_public_path__ + "static/media/alexine.9f67d80b.jpg";